import axios from 'axios'

import store from '@/store'

export async function postFeedback(checkoutId: string, rating: number, notes: string): Promise<void> {
  try {
      await axios.post('/shopify/actions', {
          checkoutId,
          type: 'feedback',
          rating,
          notes
      }, {
        headers: {
          'x-ticket-token': store.getters.getToken,
        },
      })
  } catch (error) {
      console.log('ERROR postFeedback', error)
  }

  return
}
